/* ============================================================
   EXON Accessibility Widget v5 — לוח בקרה מעוצב
   רשת אריחי אייקונים בסגנון Control Center, זכוכית כהה EXON.
   תואם WCAG 2.0 AA (ת"י 5568) ברמת הרכיב + שיפורי WCAG 2.2.
   קובץ יחיד, ללא תלות חיצונית, ללא שליחת מידע לשרת כלשהו.
   עדכון: החלף את תוכן הקובץ הקיים ב-Assets/exon-a11y.js
   ============================================================ */
(function () {
  'use strict';

  var CONFIG = {
    accent: '#11E5B8',
    side: 'right',                /* 'right' / 'left' */
    verticalOffset: 0,            /* שלילי = למעלה, חיובי = למטה (px) */
    statementUrl: '/policies/terms-of-service',
    storageKey: 'exon_a11y_v1'
  };

  /* אייקונים (SVG, currentColor) */
  var I = {
    contrast:  '<svg viewBox="0 0 24 24"><path d="M12 3a9 9 0 1 0 0 18V3z" fill="currentColor"/><circle cx="12" cy="12" r="9" fill="none" stroke="currentColor" stroke-width="2"/></svg>',
    invert:    '<svg viewBox="0 0 24 24"><path d="M12 2.5c-3.5 4.4-6.5 7.7-6.5 11a6.5 6.5 0 0 0 13 0c0-3.3-3-6.6-6.5-11z" fill="none" stroke="currentColor" stroke-width="2"/><path d="M12 2.5c-3.5 4.4-6.5 7.7-6.5 11a6.5 6.5 0 0 0 6.5 6.5V2.5z" fill="currentColor"/></svg>',
    grayscale: '<svg viewBox="0 0 24 24"><rect x="3" y="3" width="8" height="8" rx="2" fill="currentColor" opacity=".9"/><rect x="13" y="3" width="8" height="8" rx="2" fill="currentColor" opacity=".55"/><rect x="3" y="13" width="8" height="8" rx="2" fill="currentColor" opacity=".35"/><rect x="13" y="13" width="8" height="8" rx="2" fill="currentColor" opacity=".18"/></svg>',
    links:     '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><path d="M10 13a4 4 0 0 0 6 .5l3-3a4 4 0 0 0-5.7-5.6l-1.6 1.6"/><path d="M14 11a4 4 0 0 0-6-.5l-3 3a4 4 0 0 0 5.7 5.6l1.6-1.6"/></svg>',
    headings:  '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round"><path d="M6 4v16M18 4v16M6 12h12"/></svg>',
    font:      '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M4 19 10 5l6 14M6.4 14h7.2"/><path d="M15.5 19c3 0 5-1.6 5-4.2V9.5" opacity=".7"/></svg>',
    anim:      '<svg viewBox="0 0 24 24" fill="currentColor"><rect x="6" y="4" width="4" height="16" rx="1.5"/><rect x="14" y="4" width="4" height="16" rx="1.5"/></svg>',
    cursor:    '<svg viewBox="0 0 24 24" fill="currentColor"><path d="M5 3l14 8.5-6.2 1.3 3 6.5-2.7 1.2-3-6.6L5 18V3z"/></svg>',
    focus:     '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round"><path d="M4 9V6a2 2 0 0 1 2-2h3M15 4h3a2 2 0 0 1 2 2v3M20 15v3a2 2 0 0 1-2 2h-3M9 20H6a2 2 0 0 1-2-2v-3"/><circle cx="12" cy="12" r="3" fill="currentColor" stroke="none"/></svg>',
    close:     '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round"><path d="M6 6l12 12M18 6L6 18"/></svg>'
  };

  var GROUPS = [
    { title: 'תצוגה', items: [
      { id: 'contrast',  label: 'ניגודיות',   cls: 'exa-contrast',  icon: I.contrast },
      { id: 'invert',    label: 'היפוך צבעים', cls: 'exa-invert',    icon: I.invert },
      { id: 'grayscale', label: 'גווני אפור',  cls: 'exa-grayscale', icon: I.grayscale }
    ]},
    { title: 'קריאה', items: [
      { id: 'links',     label: 'הדגשת קישורים', cls: 'exa-links',    icon: I.links },
      { id: 'headings',  label: 'הדגשת כותרות',  cls: 'exa-headings', icon: I.headings },
      { id: 'font',      label: 'פונט קריא',     cls: 'exa-readable', icon: I.font }
    ]},
    { title: 'ניווט', items: [
      { id: 'anim',      label: 'עצירת תנועה', cls: 'exa-noanim', icon: I.anim },
      { id: 'cursor',    label: 'סמן מוגדל',   cls: 'exa-cursor', icon: I.cursor },
      { id: 'focus',     label: 'מיקוד מקלדת', cls: 'exa-focus',  icon: I.focus }
    ]}
  ];
  var ALL_ITEMS = GROUPS[0].items.concat(GROUPS[1].items, GROUPS[2].items);
  var SCALE_PCT = { '-1': '90%', '0': '100%', '1': '110%', '2': '120%', '3': '135%' };

  var state = { scale: 0, on: {} };
  try {
    var saved = JSON.parse(localStorage.getItem(CONFIG.storageKey));
    if (saved && typeof saved === 'object') state = { scale: saved.scale | 0, on: saved.on || {} };
  } catch (e) {}
  function persist() { try { localStorage.setItem(CONFIG.storageKey, JSON.stringify(state)); } catch (e) {} }

  var SIDE = CONFIG.side === 'left' ? 'left' : 'right';
  var RADIUS = SIDE === 'right' ? '14px 0 0 14px' : '0 14px 14px 0';
  var OFF = 'calc(50% + ' + (CONFIG.verticalOffset | 0) + 'px)';

  var css = ''
    + ':root{--exa-accent:' + CONFIG.accent + ';--exa-bg:#0d1017;--exa-glass:rgba(13,16,23,.9);--exa-line:rgba(255,255,255,.12);}'
    /* אפקטים גלובליים */
    + 'html.exa-contrast{filter:contrast(1.3);}'
    + 'html.exa-invert{filter:invert(1) hue-rotate(180deg);}'
    + 'html.exa-invert img,html.exa-invert video,html.exa-invert iframe{filter:invert(1) hue-rotate(180deg);}'
    + 'html.exa-grayscale{filter:grayscale(1);}'
    + 'html.exa-contrast.exa-grayscale{filter:contrast(1.3) grayscale(1);}'
    + 'html.exa-links a{text-decoration:underline!important;background:#ff0!important;color:#00189f!important;}'
    + 'html.exa-headings h1,html.exa-headings h2,html.exa-headings h3,html.exa-headings h4,html.exa-headings h5,html.exa-headings h6{outline:2px dashed var(--exa-accent)!important;outline-offset:2px;}'
    + 'html.exa-readable body,html.exa-readable body *{font-family:Arial,Helvetica,sans-serif!important;letter-spacing:.02em;}'
    + 'html.exa-noanim *,html.exa-noanim *::before,html.exa-noanim *::after{animation:none!important;transition:none!important;scroll-behavior:auto!important;}'
    + 'html.exa-cursor,html.exa-cursor *{cursor:url("data:image/svg+xml;utf8,<svg xmlns=%27http://www.w3.org/2000/svg%27 width=%2748%27 height=%2748%27 viewBox=%270 0 24 24%27><path fill=%27black%27 stroke=%27white%27 stroke-width=%271%27 d=%27M4 2 L20 12 L13 13.5 L16.5 21 L13.5 22 L10.5 14.5 L4 19 Z%27/></svg>") 4 2,auto!important;}'
    + 'html.exa-focus *:focus{outline:3px solid var(--exa-accent)!important;outline-offset:2px!important;}'
    + 'html[data-exa-scale="1"] body{zoom:1.1;}html[data-exa-scale="2"] body{zoom:1.2;}html[data-exa-scale="3"] body{zoom:1.35;}'
    + 'html[data-exa-scale="-1"] body{zoom:.9;}'
    /* לשונית */
    + '#exa-btn{position:fixed;' + SIDE + ':0;top:' + OFF + ';transform:translateY(-50%);z-index:999990;'
    + 'width:44px;height:44px;border-radius:' + RADIUS + ';border:1px solid var(--exa-line);border-' + SIDE + ':none;'
    + 'background:var(--exa-glass);-webkit-backdrop-filter:blur(12px) saturate(1.3);backdrop-filter:blur(12px) saturate(1.3);'
    + 'box-shadow:0 6px 20px rgba(0,0,0,.45);cursor:pointer;display:flex;align-items:center;justify-content:center;padding:0;'
    + 'transition:box-shadow .18s,border-color .18s;}'
    + '#exa-btn>svg{width:24px;height:24px;fill:var(--exa-accent);filter:drop-shadow(0 0 6px rgba(17,229,184,.45));}'
    + '#exa-btn:hover{border-color:rgba(17,229,184,.55);box-shadow:0 6px 22px rgba(0,0,0,.5),0 0 14px rgba(17,229,184,.28);}'
    + '#exa-btn:focus-visible,#exa-btn:focus{outline:3px solid var(--exa-accent);outline-offset:2px;}'
    /* פאנל */
    + '#exa-panel{position:fixed;' + SIDE + ':54px;top:' + OFF + ';transform:translateY(-50%);z-index:999991;'
    + 'width:316px;max-height:min(82vh,640px);overflow-y:auto;direction:rtl;text-align:right;'
    + 'background:var(--exa-glass);-webkit-backdrop-filter:blur(18px) saturate(1.35);backdrop-filter:blur(18px) saturate(1.35);'
    + 'color:#f4f6fa;border:1px solid var(--exa-line);border-radius:20px;'
    + 'box-shadow:0 18px 48px rgba(0,0,0,.55);padding:16px;font-family:inherit;font-size:16px;display:none;}'
    + '@supports not ((backdrop-filter:blur(1px)) or (-webkit-backdrop-filter:blur(1px))){#exa-panel,#exa-btn{background:var(--exa-bg);}}'
    + '#exa-panel.open{display:block;}'
    + '#exa-panel::-webkit-scrollbar{width:6px;}#exa-panel::-webkit-scrollbar-thumb{background:rgba(255,255,255,.18);border-radius:99px;}'
    /* כותרת */
    + '.exa-head{display:flex;align-items:center;justify-content:space-between;margin-bottom:12px;}'
    + '.exa-head h2{margin:0;font-size:16px;font-weight:800;color:#fff;display:flex;align-items:center;gap:8px;}'
    + '.exa-head h2::before{content:"";width:4px;height:18px;border-radius:99px;background:var(--exa-accent);box-shadow:0 0 8px rgba(17,229,184,.55);}'
    + '#exa-close{width:34px;height:34px;min-height:34px;border-radius:10px;border:1px solid var(--exa-line);background:rgba(255,255,255,.05);'
    + 'color:#f4f6fa;cursor:pointer;display:flex;align-items:center;justify-content:center;padding:0;}'
    + '#exa-close svg{width:16px;height:16px;}'
    + '#exa-close:hover{background:rgba(255,255,255,.12);}'
    /* בקר גודל טקסט */
    + '.exa-size{display:flex;align-items:stretch;gap:8px;margin-bottom:14px;}'
    + '.exa-size button{width:56px;min-height:48px;border-radius:14px;border:1px solid var(--exa-line);'
    + 'background:rgba(255,255,255,.05);color:#f4f6fa;cursor:pointer;font-weight:800;line-height:1;'
    + 'display:flex;align-items:center;justify-content:center;transition:background .15s,border-color .15s;}'
    + '.exa-size button:hover{background:rgba(255,255,255,.12);}'
    + '.exa-size .exa-sm{font-size:14px;}.exa-size .exa-lg{font-size:21px;}'
    + '.exa-size-val{flex:1;display:flex;flex-direction:column;align-items:center;justify-content:center;'
    + 'border-radius:14px;border:1px solid var(--exa-line);background:rgba(255,255,255,.03);}'
    + '.exa-size-val b{font-size:17px;color:var(--exa-accent);}'
    + '.exa-size-val span{font-size:11px;opacity:.75;}'
    /* קבוצות ורשת אריחים */
    + '.exa-cap{font-size:11px;font-weight:700;letter-spacing:.08em;opacity:.6;margin:12px 2px 7px;}'
    + '.exa-grid{display:grid;grid-template-columns:repeat(3,1fr);gap:8px;}'
    + '.exa-tile{display:flex;flex-direction:column;align-items:center;justify-content:center;gap:7px;'
    + 'min-height:76px;border-radius:16px;border:1px solid rgba(255,255,255,.09);background:rgba(255,255,255,.045);'
    + 'color:#f4f6fa;cursor:pointer;padding:9px 4px;text-align:center;'
    + 'transition:background .15s,border-color .15s,box-shadow .15s,transform .12s;}'
    + '.exa-tile svg{width:22px;height:22px;color:rgba(244,246,250,.85);}'
    + '.exa-tile span{font-size:12px;line-height:1.25;}'
    + '.exa-tile:hover{background:rgba(255,255,255,.1);border-color:rgba(255,255,255,.2);transform:translateY(-1px);}'
    + '.exa-tile[aria-pressed="true"]{border-color:rgba(17,229,184,.7);background:rgba(17,229,184,.13);'
    + 'box-shadow:0 0 0 1px rgba(17,229,184,.4),0 0 16px rgba(17,229,184,.22);}'
    + '.exa-tile[aria-pressed="true"] svg{color:var(--exa-accent);filter:drop-shadow(0 0 5px rgba(17,229,184,.6));}'
    + '#exa-panel button:focus-visible,#exa-panel a:focus-visible,#exa-panel button:focus,#exa-panel a:focus{outline:3px solid var(--exa-accent);outline-offset:2px;}'
    /* פוטר */
    + '.exa-foot{display:flex;gap:8px;margin-top:14px;}'
    + '.exa-foot button,.exa-foot a{flex:1;text-align:center;font-size:13.5px;min-height:44px;display:flex;align-items:center;justify-content:center;'
    + 'border-radius:999px;border:1px solid var(--exa-line);background:rgba(255,255,255,.05);color:#f4f6fa;cursor:pointer;'
    + 'transition:background .15s,border-color .15s;}'
    + '.exa-foot a{text-decoration:underline;text-underline-offset:3px;}'
    + '.exa-foot button:hover,.exa-foot a:hover{background:rgba(255,255,255,.12);border-color:rgba(255,255,255,.22);}'
    + '@media (prefers-reduced-motion:reduce){#exa-btn,.exa-tile,.exa-size button,.exa-foot button,.exa-foot a{transition:none;}.exa-tile:hover{transform:none;}}'
    + '@media (max-width:480px){#exa-panel{width:calc(100vw - 66px);' + SIDE + ':52px;}}';

  var styleEl = document.createElement('style');
  styleEl.id = 'exa-style';
  styleEl.textContent = css;
  document.head.appendChild(styleEl);

  function apply() {
    var html = document.documentElement;
    ALL_ITEMS.forEach(function (f) { html.classList.toggle(f.cls, !!state.on[f.id]); });
    if (state.scale) html.setAttribute('data-exa-scale', String(state.scale));
    else html.removeAttribute('data-exa-scale');
  }

  /* ---------- ממשק ---------- */
  var btn = document.createElement('button');
  btn.id = 'exa-btn';
  btn.type = 'button';
  btn.setAttribute('aria-label', 'תפריט נגישות');
  btn.setAttribute('aria-haspopup', 'dialog');
  btn.setAttribute('aria-expanded', 'false');
  btn.innerHTML = '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M12 2a2 2 0 1 1 0 4 2 2 0 0 1 0-4zm9 5.5c.3 0 .5.2.5.5s-.2.5-.5.5c-2.4.3-4.8.6-7 .7v3.3l2.6 8.2c.1.3-.1.6-.4.7-.3.1-.6 0-.7-.3L12 13.6l-3.5 7.5c-.1.3-.4.4-.7.3-.3-.1-.5-.4-.4-.7L10 12.5V9.2c-2.2-.1-4.6-.4-7-.7-.3 0-.5-.2-.5-.5s.2-.5.5-.5c3.2.4 6.3.7 9 .7s5.8-.3 9-.7z"/></svg>';

  var panel = document.createElement('div');
  panel.id = 'exa-panel';
  panel.setAttribute('role', 'dialog');
  panel.setAttribute('aria-modal', 'false');
  panel.setAttribute('aria-labelledby', 'exa-title');

  var inner = ''
    + '<div class="exa-head"><h2 id="exa-title">נגישות</h2>'
    + '<button type="button" id="exa-close" aria-label="סגירת תפריט נגישות">' + I.close + '</button></div>'
    + '<div class="exa-size" role="group" aria-label="גודל טקסט">'
    + '<button type="button" id="exa-font-down" aria-label="הקטנת טקסט"><span class="exa-sm">א−</span></button>'
    + '<div class="exa-size-val" aria-hidden="true"><b id="exa-size-pct">100%</b><span>גודל טקסט</span></div>'
    + '<button type="button" id="exa-font-up" aria-label="הגדלת טקסט"><span class="exa-lg">א+</span></button>'
    + '</div>';
  GROUPS.forEach(function (g) {
    inner += '<div class="exa-cap">' + g.title + '</div><div class="exa-grid">';
    g.items.forEach(function (f) {
      inner += '<button type="button" class="exa-tile" data-id="' + f.id + '" aria-pressed="false">'
            + f.icon + '<span>' + f.label + '</span></button>';
    });
    inner += '</div>';
  });
  inner += '<div class="exa-foot">'
        + '<button type="button" id="exa-reset">איפוס הגדרות</button>'
        + '<a href="' + CONFIG.statementUrl + '">הצהרת נגישות</a>'
        + '</div>';
  panel.innerHTML = inner;
  panel.querySelectorAll('.exa-tile svg, #exa-close svg').forEach(function (s) {
    s.setAttribute('aria-hidden', 'true'); s.setAttribute('focusable', 'false');
  });

  document.body.appendChild(btn);
  document.body.appendChild(panel);

  var pctEl = panel.querySelector('#exa-size-pct');
  function refreshUI() {
    panel.querySelectorAll('.exa-tile').forEach(function (el) {
      el.setAttribute('aria-pressed', state.on[el.getAttribute('data-id')] ? 'true' : 'false');
    });
    pctEl.textContent = SCALE_PCT[String(state.scale)] || '100%';
  }

  panel.addEventListener('click', function (e) {
    var tile = e.target.closest('.exa-tile');
    if (tile) {
      var id = tile.getAttribute('data-id');
      state.on[id] = !state.on[id];
      apply(); refreshUI(); persist(); return;
    }
    if (e.target.closest('#exa-font-up'))   { state.scale = Math.min(3,  state.scale + 1); apply(); refreshUI(); persist(); return; }
    if (e.target.closest('#exa-font-down')) { state.scale = Math.max(-1, state.scale - 1); apply(); refreshUI(); persist(); return; }
    if (e.target.closest('#exa-reset'))     { state = { scale: 0, on: {} }; apply(); refreshUI(); persist(); return; }
    if (e.target.closest('#exa-close'))     { closeAndRestore(); }
  });

  function focusables() { return panel.querySelectorAll('button, a[href]'); }

  function togglePanel(open) {
    var willOpen = open !== undefined ? open : !panel.classList.contains('open');
    panel.classList.toggle('open', willOpen);
    btn.setAttribute('aria-expanded', String(willOpen));
    if (willOpen) { refreshUI(); focusables()[0].focus(); }
  }
  function closeAndRestore() { togglePanel(false); btn.focus(); }

  btn.addEventListener('click', function () { togglePanel(); });

  document.addEventListener('keydown', function (e) {
    if (!panel.classList.contains('open')) return;
    if (e.key === 'Escape') { closeAndRestore(); return; }
    if (e.key === 'Tab') {
      var f = focusables();
      var first = f[0], last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
  });

  document.addEventListener('click', function (e) {
    if (panel.classList.contains('open') && !panel.contains(e.target) && e.target !== btn && !btn.contains(e.target)) {
      closeAndRestore();
    }
  });

  apply();
})();